import { get, post } from '../utils/axios'

export const getPropertyAssetAPI = async (body) => {
  return await get('propertys/assets', body)
}

export const createPropertyAssetAPI = async (body) => {
  return await post('propertys/assets', body)
}

export const getPropertyLicensesAPI = async (body) => {
  return await get('propertys/licenses', body)
}

// setting Asset IT
// search
export const getSearchAssetITAPI = async (body) => {
  return await get('emps/searchs', body)
}
// detail
export const getDetailAssetITAPI = async (uuid) => {
  return await get('emps/details/searchs', uuid)
}
